// helpers
import { useFetch } from "./reactQuery";
import API_URLS from "@/api/routes.constant";

// interfaces
import { QueryArgsInterface } from "@/types/api/queryArgs";
import { IPopularSearches } from "@/types/api/PopularSearches";

const popularSearches = {
  useGetSearches: (args?: QueryArgsInterface) => {
    const { params, config } = args || {};

    return useFetch<IPopularSearches[]>(API_URLS.popularSearches, params, config);
  },
};

export default popularSearches;
